import React from "react";
import { Button } from "reactstrap";

const BackButton = ({ type, back, disabled }) => {
  return (
    <Button
      type={type ? type : ""}
      onClick={back ? back : () => { }}
      color="soft-primary"
      disabled={disabled}
      className="btn border border-primary d-flex align-items-center justify-content-center text-center py-0  me-auto"
      style={{ width: "200px" }}
    >
      <i className="ri-arrow-left-line label-icon align-middle fs-2 me-2"></i>{" "}
      Back
    </Button>
  );
};

export default BackButton;
